import React, { useEffect, useRef } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { CheckIcon, XIcon } from "../../../constants/Icons";

const PaymentMethod = ({
  open,
  onClose,
  totalPayable,
  paymentData,
  setPaymentData,
  onDone,
  handleFocusFill,
  handleEnterFocus,
}) => {
  // console.log(totalPayable);
  const { cash, card, online, upi, paylater, totalPaid, balance } = paymentData;

  const cashRef = useRef(null);
  const cardRef = useRef(null);
  const upiRef = useRef(null);
  const onlineRef = useRef(null);
  const paylaterRef = useRef(null);
  const btnRef = useRef(null);

  const handleInputChange = (field) => (e) => {
    const value = e.target.value;

    if (value === "") {
      setPaymentData((prev) => ({
        ...prev,
        [field]: "",
      }));
      return;
    }

    if (!/^\d*\.?\d{0,2}$/.test(value)) return;

    setPaymentData((prev) => ({
      ...prev,
      [field]: Number(value),
    }));
  };

  const handleEnterKey = (e, field, nextRef = null) => {
    if (e.key !== "Enter") return;

    e.preventDefault();

    if (field) {
      const paid =
        Number(paymentData.cash || 0) +
        Number(paymentData.card || 0) +
        Number(paymentData.online || 0) +
        Number(paymentData.upi || 0) +
        Number(paymentData.paylater || 0);

      if (Number(paymentData[field] || 0) === 0) {
        const remaining = Math.max(
          0,
          CurrencyConverter.toCurrency(totalPayable, "INR") - paid,
        );

        if (remaining > 0) {
          setPaymentData((prev) => ({
            ...prev,
            [field]: Number(remaining.toFixed(2)),
          }));
        }
      }
    }

    if (nextRef?.current) {
      setTimeout(() => {
        nextRef.current.focus();

        if (nextRef.current.tagName === "INPUT") {
          nextRef.current.select();
        }
      }, 0);
    }
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  if (!open) return null;

  return (
    <div>
      <div className="modal-backdrop show"> </div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
          // onClick={stopEventPropagation}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Payment Details</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            {/* Total Section */}
            <div className="modal-body bg-light">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="rounded">
                      <div className="bg-light rounded p-2 text-center mb-3">
                        <h6 className="mb-0 fs-18 text-dark">
                          Total Payable :{" "}
                          <span>
                            {" "}
                            ₹
                            {CurrencyConverter.toCurrency(
                              Math.abs(totalPayable),
                              "INR",
                            )}{" "}
                          </span>
                        </h6>
                      </div>
                      <div className="flex-grow-1 row justify-content-between align-items-center g-2">
                        <div className="col-6">
                          <h6 className="mb-0">Cash</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            className="form-control"
                            min="0"
                            name="cash"
                            autoComplete="off"
                            value={cash}
                            ref={cashRef}
                            onClick={() => handleFocusFill("cash")}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "cash", cardRef)
                            }
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange("cash")}
                          />
                        </div>
                        <div className="col-6">
                          <h6 className="mb-0">Card</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            name="card"
                            ref={cardRef}
                            autoComplete="off"
                            className="form-control"
                            min="0"
                            value={card}
                            onClick={() => handleFocusFill("card")}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "card", onlineRef)
                            }
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange("card")}
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0">Online Pay</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            name="online"
                            ref={onlineRef}
                            autoComplete="off"
                            className="form-control"
                            min="0"
                            value={online}
                            onClick={() => handleFocusFill("online")}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "online", upiRef)
                            }
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange("online")}
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0">UPI</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            name="upi"
                            ref={upiRef}
                            className="form-control"
                            autoComplete="off"
                            min="0"
                            value={upi}
                            onClick={() => handleFocusFill("upi")}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "upi", paylaterRef)
                            }
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange("upi")}
                          />
                        </div>

                        <div className="col-6">
                          <h6
                            className={`mb-0 
                                                      ${
                                                        balance === 0
                                                          ? "text-grey"
                                                          : balance > 0
                                                            ? "text-danger"
                                                            : "text-success"
                                                      }`}
                          >
                            {balance === 0
                              ? "Balance"
                              : balance > 0
                                ? "Balance"
                                : "Change"}
                          </h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            className={`form-control ${
                              balance === 0
                                ? "bg-box-grey"
                                : balance > 0
                                  ? "bg-box-danger"
                                  : "bg-box-success"
                            }`}
                            value={CurrencyConverter.toCurrency(balance, "INR")}
                            //  value={Math.max(0, totalPayable-(cash+card+upi))}
                            disabled
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0 bg-dark-text fw-500">
                            Total Paid
                          </h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            className="form-control text-dark"
                            value={CurrencyConverter.toCurrency(
                              totalPaid || 0,
                              "INR",
                            )}
                            disabled
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0 text-brown">Paylater</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            ref={paylaterRef}
                            type="text"
                            className="form-control"
                            min="0"
                            value={paylater}
                            onClick={() => handleFocusFill("paylater")}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "paylater", btnRef)
                            }
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange("paylater")}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={onClose}
              >
                <XIcon/> Cancel
              </button>

              <button
                type="button"
                className="btn btn-primary text-right"
                ref={btnRef}
                disabled={
                  CurrencyConverter.toSubunit(totalPaid || 0, "INR") <
                  Number(totalPayable || 0)
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    onDone({
                      cash,
                      upi,
                      card,
                      online,
                      paylater,
                      totalPaid,
                    });
                  }
                }}
                onClick={() =>
                  onDone({
                    cash,
                    upi,
                    card,
                    online,
                    paylater,
                    totalPaid,
                  })
                }
              >
                <CheckIcon/> Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
